module.exports = __webpack_public_path__ + "img/preview-mobile.ce27e799.svg";